import { toSpaceCase } from "@skilitics/designer-ui-components";

import type { DesignerNode, EventDefinition, GetManifestByTypeId } from "../../types/index.ts";
import type { GetDesignerNodeById } from "./getDesignerNodeById.ts";

interface Options {
  getManifest: GetManifestByTypeId;
  getNodeById: GetDesignerNodeById;
}
export const getTriggerEventsCreate =
  ({ getManifest, getNodeById }: Options) =>
  (idOrNode: number | DesignerNode): EventDefinition[] => {
    const node = typeof idOrNode === "number" ? getNodeById(idOrNode) : idOrNode;
    const { designer } = getManifest(node.typeId);

    const triggerEventTypes = Array.isArray(designer?.triggerEventTypes)
      ? designer.triggerEventTypes
      : typeof designer?.triggerEventTypes === "function"
        ? designer.triggerEventTypes(node)
        : [];

    return triggerEventTypes.map(
      (d): EventDefinition => (typeof d === "string" ? { type: d, title: { en: toSpaceCase(d) } } : d),
    );
  };

export type GetTriggerEvents = ReturnType<typeof getTriggerEventsCreate>;
